import Main from './Main.vue'

const routes = [
  {
    name: 'billing/main',
    component: Main,
    path: '/billing',
    meta: {
      requiresAuth: true,
    },
  },
]

export { routes }
